import styled, { keyframes } from "styled-components";

const rotate = keyframes`
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
`;

export const StyledLoaderImage = styled.div`
   animation: ${rotate} 0.3s linear infinite;
   padding: 30px;
`;


